import { createRouter, createWebHashHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

// 注册功能模块的 i18n 语言包
import '@/features/home/i18n';
import '@/features/chat/i18n';
import '@/features/drafting-center/i18n';
import '@/features/templates/i18n';
import '@/features/instruction-center/i18n';
import '@/features/writing-styles/i18n';
import '@/features/patent-editor/i18n';
import '@/features/prior-art/i18n';
// Diagram 功能已临时屏蔽
// import '@/features/diagram/i18n';
import '@/features/upgrade/i18n';
import '@/features/ai-settings/i18n';
import '@/features/pricing/i18n';
import { EUREKA_URI } from '@/constants/base-url';
import '@/features/usage-management/i18n';
import '@/features/feedback/i18n';

const isDev = import.meta.env.DEV;

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/features/plg-ip-home/views/PlgIpHomePage.vue'),
        beforeEnter : () => {
            if (!isDev) {
                window.location.href = `${EUREKA_URI}/ip/#/home`;
                return false;
            }
            return true;
        },
        meta: {
            title: 'Home',
        },
    },
    {
        path: '/old-home',
        name: 'OldHome',
        component: () => import('@/features/home/views/HomePage.vue'),
    },
    {
        path: '/templates',
        name: 'Templates',
        component: () => import('@/features/templates/views/TemplatesPage.vue'),
        meta: {
            title: 'Templates',
        },
    },
    {
        path: '/templates/editor',
        name: 'TemplateEditor',
        component: () => import('@/features/templates/views/TemplateEditor.vue'),
        meta: {
            title: 'Template Editor',
        },
    },
    {
        path: '/instructions',
        name: 'AIInstructions',
        component: () => import('@/features/instruction-center/views/InstructionCenterPage.vue'),
        meta: {
            title: 'AI Instructions',
        },
    },
    {
        path: '/patent-drafting/projects',
        name: 'DraftingCenter',
        component: () => import('@/features/drafting-center/views/DraftingCenterPage.vue'),
        meta: {
            title: 'Drafting Center',
        },
    },
    {
        path: '/patent-drafting',
        name: 'PatentDrafting',
        component: () => import('@/features/patent-editor/views/PatentEditorPage.vue'),
        meta: {
            title: 'Patent Drafting',
        },
    },
    // Diagram 路由已临时屏蔽
    // {
    //     path: '/diagram',
    //     name: 'DiagramNew',
    //     component: () => import('@/features/diagram/views/DiagramPage.vue'),
    //     meta: {
    //         title: 'New Diagram',
    //     },
    // },
    // {
    //     path: '/diagram/:id',
    //     name: 'Diagram',
    //     component: () => import('@/features/diagram/views/DiagramPage.vue'),
    //     meta: {
    //         title: 'Diagram Editor',
    //     },
    // },
    {
        path: '/writing-styles',
        name: 'WritingStyles',
        component: () => import('@/features/writing-styles/views/WritingStylesPage.vue'),
        meta: {
            title: 'Writing Styles',
        },
    },
    {
        path: '/ai-settings',
        name: 'AISettings',
        component: () => import('@/features/ai-settings/views/AISettingsPage.vue'),
        meta: {
            title: 'AI Settings',
        },
    },
    {
        path: '/upgrade',
        name: 'Upgrade',
        component: () => import('@/features/upgrade/views/UpgradePage.vue'),
        meta: {
            title: 'Upgrade',
        },
    },
    {
        path: '/pricing',
        name: 'Pricing',
        redirect: '/upgrade',
    },
    {
        path: '/admin/usage-management',
        name: 'UsageManagement',
        component: () => import('@/features/usage-management/views/UsageManagementPage.vue'),
        beforeEnter: (_to, _from, next) => {
            import('@/config/admin').then(({ isSuperAdmin }) => {
                if (!isSuperAdmin()) {
                    next('/404');
                } else {
                    next();
                }
            });
        },
        meta: {
            title: 'Usage Management',
        },
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () => import('@/features/error/views/NotFoundPage.vue'),
        meta: {
            title: '404 Not Found',
        },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
